import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { HttpClientModule } from '@angular/common/http';

import { environment } from '../environments/environment';

import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth, GoogleAuthProvider } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';

import { ControllerService } from './services/controller/controller.service';



export const appConfig: ApplicationConfig = {
  providers: [
    // Router
    provideRouter(routes),
    // Animations
    provideAnimationsAsync(),
    // Http client
    importProvidersFrom(HttpClientModule),
    // Firebase
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    GoogleAuthProvider,
    // Controller service
    ControllerService,
  ]
};